import { Evento, EventoFormData } from "../types/Event";

const API_BASE_URL = "/api";

export const eventService = {
  // Get all events
  async getEventi(): Promise<Evento[]> {
    const response = await fetch(`${API_BASE_URL}/eventi`);
    if (!response.ok) {
      throw new Error("Errore nel recupero degli eventi");
    }
    return response.json();
  },

  // Get single event by ID
  async getEvento(id: number): Promise<Evento> {
    const response = await fetch(`${API_BASE_URL}/eventi/${id}`);
    if (!response.ok) {
      throw new Error("Errore nel recupero dell'evento");
    }
    return response.json();
  },

  // Get single event by slug (title-based URL)
  async getEventoBySlug(slug: string): Promise<Evento> {
    const response = await fetch(`${API_BASE_URL}/eventi/${slug}`);
    if (!response.ok) {
      throw new Error("Errore nel recupero dell'evento");
    }
    return response.json();
  },

  // Create new event
  async createEvento(evento: EventoFormData): Promise<Evento> {
    const response = await fetch(`${API_BASE_URL}/eventi`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(evento),
    });
    if (!response.ok) {
      throw new Error("Errore nella creazione dell'evento");
    }
    return response.json();
  },

  // Update existing event
  async updateEvento(id: number, evento: EventoFormData): Promise<Evento> {
    console.log(evento)
    const response = await fetch(`${API_BASE_URL}/eventi/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(evento),
    });
    if (!response.ok) {
      throw new Error("Errore nell'aggiornamento dell'evento");
    }
    return response.json();
  },

  // Duplicate event
  async duplicateEvento(id: number): Promise<Evento> {
    const response = await fetch(`${API_BASE_URL}/eventi/${id}/duplicate`, {
      method: "POST",
    });
    if (!response.ok) {
      throw new Error("Errore nella duplicazione dell'evento");
    }
    return response.json();
  },

  // Get rendered newsletter HTML for an event, without sending anything
  async getEventNewsletterPreview(id: number): Promise<{ html: string }> {
    const response = await fetch(`${API_BASE_URL}/eventi/${id}/newsletter-preview`);
    if (!response.ok) {
      throw new Error("Errore nel caricamento dell'anteprima della newsletter");
    }
    return response.json();
  },

  // Send event newsletter preview to Scarpetta admin inbox
  async sendEventNewsletter(id: number): Promise<{ success: boolean; message: string }> {
    const response = await fetch(`${API_BASE_URL}/eventi/${id}/send-newsletter`, {
      method: "POST",
    });
    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || "Errore nell'invio della newsletter");
    }
    return response.json();
  },

  // Delete event
  async deleteEvento(id: number): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/eventi/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      throw new Error("Errore nell'eliminazione dell'evento");
    }
  },

  // Upload event image
  async uploadEventImage(eventoId: number, file: File): Promise<{ url: string; blobName: string }> {
    const formData = new FormData();
    formData.append("image", file);
    
    const response = await fetch(`${API_BASE_URL}/eventi/${eventoId}/upload-image`, {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || "Errore nel caricamento dell'immagine");
    }
    return response.json();
  },
};
